import { render } from "./Inventory.vue?vue&type=template&id=4c292b5f"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"
script.render = render

export default script